import { CheckoutPrice } from '@recurly/recurly-js';

/**
 * This function corrects the subtotal calculation to ensure that discounts
 * are added back to the subtotal, while gift cards do not affect the subtotal.
 * this indicates a quirk in RJS.
 * @param price - The checkout price object
 * @returns The calculated subtotal amount as a string
 */
export function correctedSubtotal (price: CheckoutPrice): string {
  if (!price?.now) return '';

  const subtotal = Number(price.now.subtotal) || 0;
  const couponDiscount = Number(price.now.discount) || 0;

  if (couponDiscount > 0) {
    return (subtotal + couponDiscount).toString();
  } else {
    return subtotal.toString();
  }
}
